import extend from 'lodash/assign';
import keyBy from 'lodash/keyBy';
import { rejected, resolved } from 'store/createAction';
import {
  ARCHIVE_ALL_CONVERSATIONS,
  ARCHIVE_CONVERSATIONS,
  GET_ARCHIVED_CONVERSATIONS,
  GET_CONVERSATIONS,
  GET_INBOXES,
  SEND_REPLY_MESSAGE,
  SET_ACTIVE_INBOX,
  UPDATE_CONVERSATION,
  UPDATE_CONVERSATIONS,
} from '../types';

const initialState = {
  entities: {}, // inboxItems keyed by getId function
  inboxes: [], // list of inboxes
  selectedInbox: '',
};

const getId = (convo) => convo.inbox_id + ':' + convo.contact.hash;

export default (state = initialState, action) => {
  const { type, payload, meta } = action;
  switch (type) {
    case resolved(GET_INBOXES):
      return {
        ...state,
        inboxes: payload,
      };
    case SET_ACTIVE_INBOX:
      return {
        ...state,
        selectedInbox: payload,
      };
    case GET_CONVERSATIONS:
    case GET_ARCHIVED_CONVERSATIONS:
      return {
        ...state,
        loading: true,
      };

    case resolved(GET_CONVERSATIONS):
    case resolved(GET_ARCHIVED_CONVERSATIONS): {
      const entities = keyBy(payload, getId);
      return {
        ...state,
        loading: false,
        entities: {
          ...state.entities,
          ...entities,
        },
      };
    }

    case rejected(GET_ARCHIVED_CONVERSATIONS):
    case rejected(GET_CONVERSATIONS):
      return {
        ...state,
        loading: false,
      };

    case resolved(UPDATE_CONVERSATION): {
      const key = meta.inboxId + ':' + meta.convoId;
      const convo = state.entities[key];
      if (!convo) return state;
      return {
        ...state,
        entities: {
          ...state.entities,
          [key]: extend({}, convo, payload),
        },
      };
    }

    case resolved(UPDATE_CONVERSATIONS): {
      const updatedEntities = {};
      payload.forEach((c) => {
        const id = getId(c);
        const allId = `all:${c.contact.hash}`;
        if (state.entities[id]) {
          updatedEntities[id] = extend({}, state.entities[id], c);
        }
        if (allId) {
          updatedEntities[allId] = extend({}, state.entities[allId], c);
        }
      });
      return {
        ...state,
        entities: {
          ...state.entities,
          ...updatedEntities,
        },
      };
    }

    case resolved(SEND_REPLY_MESSAGE): {
      const convo = state.entities[meta.key];
      if (!convo) return state;
      return {
        ...state,
        entities: {
          ...state.entities,
          [meta.key]: {
            ...convo,
            inbox_item_read: '1',
          },
        },
      };
    }

    case resolved(ARCHIVE_ALL_CONVERSATIONS): {
      const entities = {};
      Object.keys(state.entities).forEach((id) => {
        entities[id] = {
          ...state.entities[id],
          inbox_item_archived: '1',
        };
      });
      return {
        ...state,
        entities: {
          ...state.entities,
          ...entities,
        },
      };
    }

    case resolved(ARCHIVE_CONVERSATIONS): {
      const entities = {};
      payload.forEach((i) => {
        const key = getId(i);
        const convo = state.entities[key];
        if (convo) {
          convo.inbox_item_archived = '1';
          entities[key] = { ...convo };
        }
      });
      return {
        ...state,
        entities: {
          ...state.entities,
          ...entities,
        },
      };
    }

    default:
      return state;
  }
};
